import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Manubar from "./Manubar";

import "./MyOrders.css";

const MyOrders = () => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState("Lease");
  const [orderList, setOrderList] = useState([]);
  const [loading, setLoading] = useState(true);

  const _id = secureLocalStorage.getItem("n_id");


  console.log(_id)
  // Fetch orders
  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      let data = {
        user_id: _id,
        order_status: "Accepted",
      };
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/my_order_status`,
        data,
      );

      if (res.data.result) {
        setOrderList(res.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoading(false);
    }
  };

  // Filter orders by type
  const filteredOrders = orderList.filter((order) => {
    const typeMatch = order.available_status === selectedType;
    return typeMatch;
  });

  // Navigate to track order
  const handleTrackOrder = (order) => {
    navigate("/trackOrder", { state: { orderData: order } });
  };

  return (
    <div className="my-orders-container">

      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Shearchbar />

        <Navbar />
      </header>
      {/* Header */}
      <div className="my-orders-header">
        <h2>My Orders</h2>
      </div>

      {/* Tabs */}
      <div className="order-tabs">
        <button
          className={`tab-button ${selectedType === "Lease" ? "active" : ""}`}
          onClick={() => setSelectedType("Lease")}
        >
          Lease Orders
        </button>
        <button
          className={`tab-button ${selectedType === "Buy" ? "active" : ""}`}
          onClick={() => setSelectedType("Buy")}
        >
          Buy Orders
        </button>
      </div>

      {/* Orders List */}
      <div className="orders-content">
        {loading ? (
          <div className="loading-state">
            <p>Loading orders...</p>
          </div>
        ) : filteredOrders.length > 0 ? (
          <div className="orders-list">
            {filteredOrders.map((order, index) => (
              <div key={index} className="order-card">
                <div className="order-header">
                  <p className="order-number">Order No.: {order.order_no}</p>
                </div>

                <div className="order-content">
                  <div className="order-product">
                    <div className="product-image1">
                      <img
                        src={`${process.env.REACT_APP_API}uploads/${order.products[0]?.product_image}`}
                        alt={order.product_name}
                        onError={(e) => {
                          e.target.src = "/placeholder.png";
                        }}
                      />
                    </div>
                    <div className="product-details">
                      <h3>{order?.products[0]?.product_title}</h3>
                      <div className="order-status">
                        <span className="status-dot"></span>
                        <span className="status-text">
                          {order.order_status || "Order Confirmed"}
                        </span>
                        <i
                          className="las la-angle-right"
                          onClick={() => handleTrackOrder(order)}
                        ></i>
                      </div>
                    </div>
                  </div>

                  <div className="order-actions">
                    <button
                      className="view-less-btn"
                      onClick={() => handleTrackOrder(order)}
                    >
                      View Less Order
                    </button>
                    <button
                      className="order-details-btn"
                      onClick={() => handleTrackOrder(order)}
                    >
                      Order Details
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-orders">
            <p>No {selectedType.toLowerCase()} orders found.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyOrders;
